import axios from 'axios';
import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom';

export default function MatchingGaps(props) {
    const location = useLocation()
   const [id, setId] = useState(props.id ? props.id : new URLSearchParams(location.search).get('id'));
   const [type, setType] = useState(props.id ? props.id : new URLSearchParams(location.search).get('type'));
   const [data, setData] = useState([]);
   const [words, setwords] = useState([]);
   const [checked, setChecked] = useState([]);
   const getData = () => {
      axios.get("/appi/table/grid/"+id, { withCredentials: true })
      .then(response => {
      
         setData(response.data);
         
          setwords(response.data[0].answer.trim().split(' '));
          console.log(response.data[0].answer.trim().split(" "))
         
         
      })
      .catch(error => {});
   }

    useEffect(()=>{
      getData();
     },[])

     const onClickHundler =(e)=>{

     }


   const replaceGap= (textfrom,text) => {
     let res = '';
     if(textfrom){
      if(textfrom.includes("______")){
         res = textfrom.replace("______",text);
        }else if(textfrom.includes("_____")){
         res = textfrom.replace("_____",text);
        }else if(textfrom.includes("____")){
         res = textfrom.replace("____",text);
        }else if(textfrom.includes("___")){
          res = textfrom.replace("___",text);
        }else if(textfrom.includes("__")){
          res = textfrom.replace("__",text);
        }else if(textfrom.includes("_")){
          res = textfrom.replace("_",text);
        }
     }
    
      return res; 
   }

   const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
   
    e.target.className = 'test-quiz-button  dragging';
    console.log(' handleDragStart index -'+index);
  };
  const handleDragEnd = (e, index) => {
  //  e.dataTransfer.setData("text/plain", index);
    e.target.className = 'test-quiz-button  ';
  };
  const isRightAnswer = (answer, index) => {
    let result = answer.toLowerCase().trim().includes(data[index].answer.toLowerCase().trim());
    return result;
  }

  const isFinished = () => {
    for( let el of data) {
      if(el.value.includes('_')) return false;
    }
    return true;
  } 

  const strictMode = (e, dropIndex, dragIndex, updatedItems) => {
      if (updatedItems[dragIndex].toLowerCase().trim() === data[dropIndex].answer.toLowerCase().trim() && data[dropIndex].value.includes('_')){
            e.target.className = 'test-quiz-correct';
            checked.push(dropIndex);
            console.log(checked);
            console.log('index -'+dropIndex);
            const [removed] = updatedItems.splice(dragIndex, 1); // Usuń przeciągany element
            setwords(updatedItems);
            data[dropIndex].value = replaceGap(data[dropIndex].value,removed);
        } else if ( data[dropIndex].value.includes('_') ) {
            e.target.className = 'test-quiz-gone';
        }
    }

    const softMode = (e, dropIndex, dragIndex, updatedItems) => {
      if (data[dropIndex].value.includes('_')) {
          e.target.className = 'test-quiz-correct';
          checked.push(dropIndex);
          console.log(checked);
          console.log('index -'+dropIndex);
          const [removed] = updatedItems.splice(dragIndex, 1); // Usuń przeciągany element
          setwords(updatedItems);
          data[dropIndex].value = replaceGap(data[dropIndex].value,removed);
      } 
      // else if ( data[dropIndex].value.includes('_') ) {
      //     e.target.className = 'test-quiz-gone';
      // }
  }

    const handleDrop = (e, dropIndex) => {
     // alert(dropIndex);
    // e.target.className = 'test-quiz-gone';
      const dragIndex = e.dataTransfer.getData("text/plain");
      const updatedItems = [...words];
      if (type==='strict') {
          strictMode(e, dropIndex, dragIndex, updatedItems);
      } else {
         softMode(e, dropIndex, dragIndex, updatedItems);
      }

    
     // e.innerHTML = "sdsd";
    };

    const handleDragOver = (e,index) => {
    e.preventDefault(); // Wymagane, aby obsłużyć zdarzenie "drop"
   
    if( !checked.includes(index) ){
      e.target.className = 'test-quiz-done ';
    }
   };
   const handleDragOverExit = (e,index) => {
    e.preventDefault(); // Wymagane, aby obsłużyć zdarzenie "drop"
    if( !checked.includes(index) ){
      e.target.className = 'test-quiz-gone';
    }
    
   };
  return (
    <div className='test-quiz-container'>

      <div className='test-quiz-block' >
      {
      
      
      Array.isArray(words) ?
      Object.values( words.map( (item, index) => (
            
              
               <div onClick={(e) => onClickHundler(e.currentTarget)} className={'test-quiz-button '} 
               key={index} style={{cursor: "grab",}}
               draggable 
               onDragStart={(e) => handleDragStart(e, index)} onDragEnd={(e) => handleDragEnd(e, index)}
               >{item}</div> ))
             )  
             : ('') }
      </div>
      <div >
      {
      Array.isArray(data) ?
      Object.values( data.map( (item, index) => (
            
              index !== 0 ? (
              <div style={{justifyContent: 'left',display:'flex',width:'100%'}} 
               >
                <div style={{marginBlock:'auto',minWidth:35}}>
                  <svg xmlns="http://www.w3.org/2000/svg" 
                  height="24px" viewBox="0 -960 960 960" 
                  style={{fontSize:20,marginInline:5, 
                    display:  (isFinished() && isRightAnswer( item.value, index) ) || (isRightAnswer( item.value, index) && type === 'strict')  ?   'flex':'none', }}
                  width="24px" fill="#47d772"><path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" 
                  height="24px" viewBox="0 -960 960 960" 
                  style={{fontSize:20,marginInline:5, 
                    display: isFinished() && !isRightAnswer( item.value, index) && type==='soft'  ? 'flex':'none', }}
                  width="24px" fill="#d74747ff">
                    <path d="M330-120 120-330v-300l210-210h300l210 210v300L630-120H330Zm36-190 114-114 114 114 56-56-114-114 114-114-56-56-114 114-114-114-56 56 114 114-114 114 56 56Zm-2 110h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/>
                    
                  </svg>
                </div>
              
                 <span style={{marginBlock:'auto',fontSize:20,marginRight:10}}> {index}.</span>
                 <h2 style={{textAlign:'left',marginBlock:5, paddingInline:10}} key={item.answer} data-elid={item.id} 
                 onDrop={(e) => handleDrop(e, index)} onDragOver={(e) =>handleDragOver(e, index)} 
                 onDragLeave={(e) =>handleDragOverExit(e, index)}
                   >{item.value}</h2> 
              </div>)  : ('') ))
             )  
             : ('') }
      </div>
  
      
    </div>
  )
}